const cardOptions =
    {
        type: 'Тариф',
        name: 'IPnet СТАРТ',
        description: 'ІНТЕРНЕТ 100 Мбіт/с',
        costDetails: {
            fullCost: 69,
            oldCost: 220,
            discount: '69%',
            unit: {
                currency: 'грн',
                month: 'міс'
            },
        },
        underText: 'Тариф дійсний в місті Київ'
    }

export default cardOptions
